jQuery(document).ready(function ($) {
    // const header_form = $('.homepage-hero__form.request-a-free-quote__form');

    // if (header_form && header_form?.length > 0) {
    //     setTimeout(function () {
    //         header_form.addClass('active');
    //     }, 2500);
    // }

    $('#primary_navigation .menu-item-has-children').each(function () {
        $(this).append('<button class="toggle-menu"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.3"><path d="M6 4L9.99937 7.99937L6 11.9987" stroke="#130E0C" stroke-width="1.49976" stroke-linecap="round" stroke-linejoin="round"/></g></svg></button>');
    });

    $('.toggle-menu').on('click', function () {
        $(this).parent().find('ul.sub-menu').toggleClass('active');
        $(this).toggleClass('active');
        $(this).closest('li.menu-item').toggleClass('active');
    });

    $('.company-highlights__item').hover(function () {
        const idx = $(this).index();
        $('.company-highlights__images img').removeClass('active');
        $('.company-highlights__images img').eq(idx).addClass('active');
    }, function () {
        $('.company-highlights__images img').removeClass('active');
        $('.company-highlights__images img').eq(0).addClass('active');
    });

    $('.faq__item').on('click', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        }
        else {
            $('.faq__item').removeClass('active');
            $(this).addClass('active');
        }
    });

    $('.gfield input, .gfield textarea, .gfield select').on('focus', function () {
        $('.gfield').removeClass('active');
        $(this).closest('.gfield').addClass('active');
    });

    $('.gfield input, .gfield textarea, .gfield select').on('blur', function () {
        $('.gfield').removeClass('active');
    });

    const setupTextareas = (form) => {
        const gfTextarea = form.find('.gfield--type-textarea');
        if (gfTextarea && gfTextarea?.length > 0) {
            gfTextarea.each(function () {
                const maxLength = gfTextarea.find('textarea').attr('maxlength') || false;

                if (!maxLength) {
                    return;
                }

                if ($(this).find('.gform-char-counter').length === 0) {
                    const lgt = $(this).find('textarea').val().length;
                    $(this).append('<div class="gform-char-counter"><span>' + lgt + '</span> / ' + maxLength + '</div>');
                }


                $(this).find('textarea').on('input', function () {
                    const length = $(this).val().length;
                    if (length <= maxLength) {
                        $(this).closest('.gfield').find('.gform-char-counter span').text(length);
                        return;
                    }
                });
            });
        }
    }

    const handleClickOnDropdownItem = (form) => {
        $(document).on('click', '.gform-dropdown-item', function (e) {
            e.stopImmediatePropagation();
            const placeholder = $(this).closest('.gfield').find('.gform-select-placeholder');
            const isMultiSelect = ($(this).closest('.gfield--type-multiselect')?.length || 0) > 0;
            let allValues = [];
            const thisValue = $(this).text();

            if (isMultiSelect) {
                allValues = $(this).closest('.gfield').find('select').val();
            }

            if ($(this).hasClass('active')) {
                $(this).removeClass('active');

                if (isMultiSelect) {
                    const idx = allValues.indexOf(thisValue);
                    if (idx > -1) {
                        allValues.splice(idx, 1);
                    }

                    placeholder.text(allValues.join(', '));
                    if (allValues.length === 0) {
                        placeholder.text(placeholder.attr('data-initial'));
                    }

                    $(this).closest('.gfield').find('select').val(allValues);
                }
                else {
                    $(this).closest('.gfield').find('select').val('');
                    placeholder.text(placeholder.attr('data-initial'));
                }

                return;
            }

            if (isMultiSelect) {
                const newPlaceholder = allValues.length == 0 ? thisValue : placeholder.text() + ', ' + thisValue;
                const idx = allValues.indexOf(thisValue);

                if (idx > -1) {
                    allValues.splice(idx, 1);
                }
                else {
                    allValues.push(thisValue);
                }

                $(this).closest('.gfield').find('select').val(allValues);
                placeholder.text(newPlaceholder);
            }
            else {
                $(this).parent().find('.gform-dropdown-item').removeClass('active');
                $(this).closest('.gfield').find('select').val($(this).text());
                placeholder.text($(this).text());
            }

            $(this).addClass('active');
        });
    }

    const setupSelects = (form) => {
        const gfSelect = form.find('.gfield--type-select, .gfield--type-multiselect');
        if (gfSelect && gfSelect?.length > 0) {
            gfSelect.each(function () {
                let placeholderText;

                if ($(this).hasClass('gfield--type-select')) {
                    placeholderText = $(this).find('.gf_placeholder')?.text();
                }
                else {
                    placeholderText = $(this).find('.gfield_description')?.text();
                }

                if ($(this).find('.gform-select-placeholder').length === 0 && placeholderText != '') {
                    if ($(this).find('.ginput_container_select').length > 0) {
                        $(this).find('.ginput_container_select').prepend('<div class="gform-select-placeholder">' + placeholderText + '</div>');
                    }

                    if ($(this).find('.ginput_container_multiselect').length > 0) {
                        $(this).find('.ginput_container_multiselect').prepend('<div class="gform-select-placeholder">' + placeholderText + '</div>');
                    }
                }

                $(this).find('.gform-select-placeholder').attr('data-initial', placeholderText);

                if (placeholderText) {
                    if ($(this).find('.gf_placeholder')) {
                        $(this).find('.gf_placeholder').text('');
                    }
                    else {
                        $(this).find('.gfield_description').text('');
                    }

                    $(this).find('select').on('input', function () {
                        $(this).parent().find('.gform-select-placeholder').hide();

                        if ($(this).val() == '') {
                            $(this).parent().find('.gform-select-placeholder').show();
                        }
                    });
                }

                if ($(this).find('.gform-dropdown-replace').length === 0) {
                    $(this).append('<div class="gform-dropdown-replace"></div>');
                    if ($(this).find('select option').length > 10) {
                        $(this).append('<div class="gform-dropdown-container gform-dropdown-container-capped"><div class="gform-dropdown-items"></div></div>');
                    }
                    else {
                        $(this).append('<div class="gform-dropdown-container"><div class="gform-dropdown-items"></div></div>');
                    }

                    $(this).find('select option').each(function () {
                        if ($(this).val() != '') {
                            $(this).closest('.gfield--type-select').find('.gform-dropdown-container .gform-dropdown-items').append('<div class="gform-dropdown-item">' + $(this).text() + '</div>');

                            if ($(this).closest('.gfield--type-select').length == 0) {
                                $(this).closest('.gfield--type-multiselect').find('.gform-dropdown-container .gform-dropdown-items').append('<div class="gform-dropdown-item">' + $(this).text() + '</div>');
                            }
                        }
                    });
                }

                // if the select values already exist, make sure to set the placeholder and check off the correct dropdown items
                const thisSelect = $(this).find('select').val();
                if (thisSelect != '') {
                    const thisSelectPlaceholder = typeof thisSelect === 'object' ? thisSelect.join(', ') : thisSelect;
                    $(this).find('.gform-select-placeholder').text(thisSelectPlaceholder);

                    $(this).find('.gform-dropdown-items .gform-dropdown-item').each(function () {
                        const dropdownValue = $(this).text();
                        if (dropdownValue == thisSelect || (typeof thisSelect === 'object' && thisSelect.indexOf(dropdownValue) > -1)) {
                            $(this).addClass('active');
                        }
                    });
                }
            });
        }
    }

    const handleClickOutsideForm = (form) => {
        $(document).on('click', function (e) {
            if (!form.find(e.target).closest('.gfield--type-select').length) {
                form.find('.gfield--type-select').removeClass('active');
            }

            if (!form.find(e.target).closest('.gfield--type-multiselect').length) {
                form.find('.gfield--type-multiselect').removeClass('active');
            }
        });
    }

    const customGravityFormsJS = (form) => {
        setupTextareas(form);

        setupSelects(form);

        form.find('.gfield--type-select, .gfield--type-multiselect').on('click', function (e) {
            if (!$(this).hasClass('gfield--type-select') && !$(this).hasClass('gfield--type-multiselect')) {
                return;
            }

            $('.gfield--type-select, .gfield--type-multiselect').removeClass('active');
            $(this).addClass('active');
        });

        handleClickOutsideForm(form);

        handleClickOnDropdownItem(form);
    }

    $(document).on('gform_post_render', function (event, formId) {
        const form = $('#gform_wrapper_' + formId);
        form.removeClass('dscp-initialized');

        if (!form.hasClass('dscp-initialized')) {
            customGravityFormsJS(form);
            form.addClass('dscp-initialized');
        }
    });

    const infoStripSlider = () => {
        if ($('.info-strip')?.length > 0) {
            const slider = $('.info-strip .info-strip__inner');
            const slides = slider.html();

            if ($(window).width() <= 1000) {
                if (slider.hasClass('slick-initialized')) {
                    return;
                }

                slider.slick({
                    responsive: [
                        {
                            breakpoint: 1000,
                            settings: {
                                slidesToScroll: 1,
                                slidesToShow: 1,
                                variableWidth: true,
                                centerMode: true,
                                centerPadding: 20,
                                arrows: false,
                                dots: false,
                                autoplay: true,
                                autoplaySpeed: 0,
                                speed: 5000,
                                loop: true,
                                infinite: true,
                                cssEase: 'linear'
                            }
                        }
                    ]
                });
            }
            else {
                try {
                    if (slider.hasClass('slick-initialized')) {
                        slider.slick('unslick');
                        slider.find('.info-strip__inner').append(slides);
                    }
                }
                catch (e) { }
            }
        }
    }

    infoStripSlider();

    $(window).on('resize', function () {
        infoStripSlider();
    });

    $('.table-of-contents__title').on('click', function () {
        $('.table-of-contents').toggleClass('active');
    });

    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {

            // detect new nodes being added
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType !== 1) return;

                const $targets = $(node).is('.gform-select-placeholder')
                    ? $(node)
                    : $(node).find('.gform-select-placeholder');

                $targets.each(function () {
                    watchPlaceholder(this);
                });
            });

            // detect text changes
            if (mutation.type === 'characterData') {
                const $el = $(mutation.target).closest('.gform-select-placeholder');
                updateState($el);
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
    });

    function watchPlaceholder(el) {
        const $el = $(el);

        updateState($el);

        const innerObserver = new MutationObserver(function () {
            updateState($el);
        });

        innerObserver.observe(el, {
            childList: true,
            characterData: true,
            subtree: true
        });
    }

    function updateState($el) {
        if (!$el.length) return;

        if ($el.text() === $el.data('initial')) {
            $el.removeClass('has-value');
        } else {
            $el.addClass('has-value');
        }
    }

    $('.list-boxes__item').on('click', function(e){
        if ($(e.target).hasClass('list-boxes__item__list') || $(e.target).closest('.list-boxes__item__list')?.length > 0) {
            return;
        }

        $(this).toggleClass('active');
    })
});